<template>
  <md-dialog
    :md-active.sync="isOpen"
    :md-backdrop="true"
    :md-fullscreen="true"
    :md-close-on-esc="true"
    v-on:md-closed="onClose"
  >
    <md-dialog-title>
      <div class="">
        <div>
         Add A New Virtual Account
        </div>
      </div>
    </md-dialog-title>

     <md-dialog-content>
      <!-- Fields -->
      <div>
        <md-field>
          <label for="name">Meter Number</label>
          <md-input
            v-model="form.meterNo"
            placeholder="Enter Meter Number"
            id="name"
          ></md-input>
        </md-field>
        <md-field>
          <label for="email"> Service Provider </label>
          <md-select
        class="dropdown"
        name="provider"
        id="provider"
        v-model="form.serviceProviderID"
      >
        <md-optgroup label="ELECTRICITY">
          <md-option
            style="padding-left: 18px"
            v-for="(d, i) in discos"
            :value="d.code"
            :key="i"
            >{{ d.name.toUpperCase() }}</md-option
          >
        </md-optgroup>
        <!-- <md-optgroup label="TV">
          <md-option
            style="padding-left: 18px"
            v-for="(d, i) in providers"
            :value="d.code"
            :key="i"
            >{{ d.name.toUpperCase() }}</md-option
          >
        </md-optgroup> -->
        <!-- <md-optgroup label="Telcos">
          <md-option
            style="padding-left: 18px"
            v-for="(d, i) in telcos"
            :value="d.code"
            :key="i"
            >{{ d.name.toUpperCase() }}</md-option
          >
        </md-optgroup> -->
      </md-select>
        </md-field>
      </div>

      <div>
        <md-button
          class="md-block md-primary"
          @click="createNewAccount()"
          >{{isLoading ? 'Creating ... PLEASE WAIT' : 'Create Account'}}</md-button
        >
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button @click="onClose()">Close</md-button>
    </md-dialog-actions>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </md-dialog>

</template>

<script>
import { format } from 'date-fns';
import http from '../../../utils/Http.util';

export default {
  props: {
    phone: {
      type: String,
      required: true,
    },
    callback: {
      type: Function,
      required: true,
    },
  },
  name: 'customer-modal',
  data() {
    return {
      isOpen: false,
      isLoading: false,
      form: {
        meterNo: null,
        serviceProviderID: null,
      },
      snackBar: {
        show: false,
        message: null,
      },
      discos: [
        { name: 'ABUJA', code: 1 },
        { name: 'KADUNA', code: 9 },
        { name: 'JOS', code: 5 },
        { name: 'ENUGU', code: 23 },
        { name: 'PH', code: 13 },
        { name: 'EKO', code: 18 },
        { name: 'IKEJA', code: 17 },
        { name: 'IBADAN', code: 19 },
      ],
      providers: [{ name: 'dstv', code: 247 }, { name: 'gotv', code: 246 }, { name: 'startimes', code: 245 }],
      telcos: [{ name: 'mtn', code: 79 }, { name: 'glo', code: 50 }, { name: 'airtel', code: 51 }, { name: '9mobile', code: 49 }],
    };
  },
  methods: {
    format,
    onOpen() {
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
    async createNewAccount() {
      try {
        if (!this.form.meterNo || !this.form.serviceProviderID) {
          this.snackBar = {
            show: true,
            message: 'Please Provide a Valid Meter Number and a Provider',
          };
          return;
        }
        if (this.isLoading) {
          this.snackBar = {
            show: true,
            message: 'Operation In Progress',
          };
          return;
        }
        this.$store.commit('busyStatus', true);
        this.isLoading = true;

        await http.authReq(`/dashboard/customers/${this.phone}/virtual-accounts`, {
          ...this.form,
        },
        'post');

        this.$store.commit('busyStatus', false);
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: 'Successfully',
        };
        this.form.meterNo = '';
        this.form.serviceProviderID = null;
        this.onClose();
        this.callback(true); // To reload List
      } catch (err) {
        this.form.meterNo = '';
        this.form.serviceProviderID = null;
        this.onClose();
        this.$store.commit('busyStatus', false);
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: err.message || 'Unable to Create Account',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.table-body {
  overflow-x: auto;
  scroll-behavior: auto;
}

.md-dialog /deep/.md-dialog-container {
  // max-width: 100%;
  min-width: 30%;
}

.body {
  max-width: 100%;
}
</style>
